module.exports = __webpack_public_path__ + "img/5.4a7991c1.png";